import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '@shared/services/loading.service';
import { UserService } from '@shared/services/user.service';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { StartupService } from '@shared/services/startup.service';
import { Settings } from 'luxon';
import { BaseComponent } from './components/base-component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent extends BaseComponent implements OnInit, AfterContentChecked {
  public static defaultTitle = 'JOVACO POP';

  private currentLang: string;
  private defaultLang: string;

  public isLoadingGlobal: boolean;

  public constructor(
    private translateService: TranslateService,
    public dialog: MatDialog,
    private userService: UserService,
    private loadingService: LoadingService,
    private startupService: StartupService,
    private logger: NGXLogger
  ) {
    super();
  }

  public async ngOnInit() {
    this.logger.info(`*****POP START*****`);
    this.logger.info(`*****${environment.version}*****`);

    this.subscribe(
      this.loadingService.observeIsLoading().subscribe(isLoading => {
        this.isLoadingGlobal = isLoading;
      })
    );

    await this.startupService.start();

    const browserLanguage: string = navigator.language.split('-')[0];
    this.translateService.setDefaultLang(browserLanguage);
    this.defaultLang = browserLanguage;

    this.initDateConfig();
  }

  public ngAfterContentChecked() {
    if (this.userService.user) {
      if (this.userService.user.languageCode === 'fr' || this.userService.user.languageCode === 'en') {
        this.currentLang = this.userService.user.languageCode;
        this.translateService.use(this.currentLang);
      } else {
        this.currentLang = this.defaultLang;
        this.translateService.use(this.currentLang);
      }
    }
  }

  private initDateConfig() {
    Settings.defaultZone = 'utc';
    Settings.defaultLocale = this.defaultLang;
    this.subscribe(this.translateService.onLangChange.subscribe(({ lang }) => (Settings.defaultLocale = lang)));
  }
}
